// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LinkMembershipRequestModel from '../../model/link-membership-request-model';
import LinkMembershipRequestDTO from '../dto/link-membership-request-dto';
import dtoSchema from '../schemas/link-membership-request-schema';

export default abstract class LinkMembershipRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LinkMembershipRequestDTO>) {
    super();
    if (data) {
      this.verificationCode = data.verificationCode;
    }
  }
  /**
  */
  verificationCode?: string;

  static toModel(dto: DeepPartial<LinkMembershipRequestDTO>): LinkMembershipRequestModel;
  static toModel(dto: DeepPartial<LinkMembershipRequestDTO> | undefined | null): LinkMembershipRequestModel | undefined;
  static toModel(dto: DeepPartial<LinkMembershipRequestDTO> | undefined | null): LinkMembershipRequestModel | undefined {
    return dto ? new LinkMembershipRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LinkMembershipRequestModel> | LinkMembershipRequestModel): LinkMembershipRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      verificationCode: unwrapped.verificationCode,
    } as LinkMembershipRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LinkMembershipRequestModel, can not map to LinkMembershipRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
